import { setScratchConnect } from "../store/speakerSlice";
// 将file文件上传转化为base64进行显示
export function getBase64(file) {
  return new Promise((resolve, reject) => {
    ///FileReader类就是专门用来读文件的
    const reader = new FileReader();
    //开始读文件
    //readAsDataURL: dataurl它的本质就是图片的二进制数据， 进行base64加密后形成的一个字符串，
    reader.readAsDataURL(file);
    // 成功和失败返回对应的信息，reader.result一个base64，可以直接使用
    reader.onload = () => resolve(reader.result);
    // 失败返回失败的信息
    reader.onerror = error => reject(error);
  });
}

export function getScratchURL(){
  return window.location.host.indexOf('aimaker.space') > -1 ?
  'https://make.aimaker.space' :
  'https://make.dev.longan.eliteu.xyz';
}
export function getBlocksURL(){
  return window.location.host.indexOf('aimaker.space') > -1 ?
  'https://blocks.aimaker.space' :
  'https://microblocks.eliteu.xyz';
}
export function openScratch(dispatch) {
  dispatch(setScratchConnect(true))
  let data = window.open(getScratchURL() + '/projects/editor/', "editor")
  sessionStorage.setItem('win', 'true');
  let time = setInterval(() => {
    if (data.closed) {
      dispatch(setScratchConnect(false))
      sessionStorage.setItem('win', 'false');
      clearInterval(time);
    }
  }, 2000)
}